// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_2 from '/build/src/models/useMapModel';
import model_3 from '/build/src/models/useModalModel';
import model_4 from '/build/src/models/useQueryModel';
import model_6 from '/build/src/pages/Goods/Detail/models/useGoodsModel';
import model_7 from '/build/src/pages/Order/FeeActivity/models/useFeeActivityDetailModel';
import model_8 from '/build/src/pages/Order/OwedGoods/models/useOwedGoodsModel';
import model_9 from '/build/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from '/build/src/models/useCommonModel';
import model_5 from '/build/src/models/useSupplyConfigModel';

export const models = {
model_2: { namespace: 'useMapModel', model: model_2 },
model_3: { namespace: 'useModalModel', model: model_3 },
model_4: { namespace: 'useQueryModel', model: model_4 },
model_6: { namespace: 'Goods.Detail.useGoodsModel', model: model_6 },
model_7: { namespace: 'Order.FeeActivity.useFeeActivityDetailModel', model: model_7 },
model_8: { namespace: 'Order.OwedGoods.useOwedGoodsModel', model: model_8 },
model_9: { namespace: '@@initialState', model: model_9 },
model_1: { namespace: 'useCommonModel', model: model_1 },
model_5: { namespace: 'useSupplyConfigModel', model: model_5 },
} as const
